import { Upload, FileSpreadsheet, X, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { useLanguage } from "@/lib/LanguageContext";

const FileUploader = ({
  file,
  isUploading,
  isDragOver,
  uploadProgress,
  domains,
  onDragOver,
  onDragLeave,
  onDrop,
  onFileSelect,
  onRemoveFile,
}) => {
  const { t } = useLanguage();

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-8 h-8 rounded-lg bg-yellow-400/10 flex items-center justify-center text-yellow-400 font-bold text-sm">
          1
        </div>
        <h2
          className="text-xl font-bold text-white"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          {t("upload.stepTitle")}
        </h2>
      </div>

      {/* Dropzone */}
      <div
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
        className={`
          relative rounded-xl p-10 text-center cursor-pointer
          dropzone-dark
          ${isDragOver ? "dropzone-active" : ""}
          ${file ? "border-green-500/30 bg-green-500/5 cursor-default" : ""}
        `}
        data-testid="file-dropzone"
      >
        {!file && (
          <input
            type="file"
            accept=".csv,.xls,.xlsx"
            onChange={onFileSelect}
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            data-testid="file-input"
          />
        )}

        {isUploading ? (
          <div className="space-y-4">
            <div className="w-16 h-16 mx-auto rounded-xl bg-yellow-400/10 flex items-center justify-center">
              <Loader2 className="w-8 h-8 text-yellow-400 animate-spin" />
            </div>
            <p className="text-sm text-white/50">{t("upload.parsing")}</p>
            <Progress value={uploadProgress} className="h-1 bg-white/5" />
          </div>
        ) : file ? (
          <div className="space-y-3 relative z-10">
            <div className="w-16 h-16 mx-auto rounded-xl bg-green-500/10 flex items-center justify-center">
              <FileSpreadsheet className="w-8 h-8 text-green-400" />
            </div>
            <p className="font-medium text-white">{file.name}</p>
            <p className="text-sm text-white/50">{t("upload.domainsFound", { count: domains.length })}</p>
            <Button
              variant="ghost"
              size="sm"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onRemoveFile();
              }}
              className="text-red-400 hover:text-red-300 hover:bg-red-500/10 relative z-20"
              data-testid="remove-file-btn"
            >
              <X className="w-4 h-4 mr-1" /> {t("upload.remove")}
            </Button>
          </div>
        ) : (
          <div className="space-y-3">
            <div className="w-16 h-16 mx-auto rounded-xl bg-white/5 flex items-center justify-center">
              <Upload className="w-8 h-8 text-white/30" />
            </div>
            <p className="font-medium text-white">
              {t("upload.dropzone")}
            </p>
            <p className="text-sm text-white/40">
              {t("upload.formats")}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FileUploader;
